{
  "DE": "Allemagne",
  "AT": "Autriche",
  "BE": "Belgique",
  "DK": "Danemark",
  "ES": "Espagne",
  "FR": "France",
  "IE": "Irlande",
  "IT": "Italie",
  "LU": "Luxembourg",
  "MC": "Monaco",
  "NL": "Pays-Bas",
  "PL": "Pologne",
  "PT": "Portugal",
  "SE": "Suède"
}
